export class TipoPagamento {
    codigo: string;
    descricao: string;
}
